import axios from "axios";

import API_URL from "../Constants";
import { resetAppState } from "../utils/Utils";

const token =
    localStorage.getItem("appState") && localStorage.getItem("appState").includes("token")
        ? JSON.parse(localStorage.getItem("appState"))["profile"]["token"]
        : undefined;

const client = axios.create({
    baseURL: API_URL,
    headers: { Authorization: `Bearer ${token}` },
    // withCredentials: true,
});

client.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        if (error.response.status === 401) {
            console.log("Session expired resetting local storage ");
            resetAppState();
            window.location.href = "/login";
        }
        if (error.response.status === 400) {
            console.log(error.response);
            console.log(error.config.url);
            console.log("Whoot");
            if (error.config.url.includes("/v1/prices")) {
                alert("Duplicate price relation");
                window.location.href = "/products/cannabis";
            }
        }
        if (error.response.status === 403) {
            alert("Toegang geweigerd: U heeft niet voldoende rechten om deze actie uit te voeren.");
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export function setUser(token) {
    if (token) {
        client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
}

function lookupData(response) {
    return response.data;
}

function axiosFetch(path, options = {}, headers = {}, showErrorDialog = true, result = true) {
    // preset the config with the relative URL and a GET type.
    // presets can be overridden with `options`.
    return client({ url: path, method: "GET", ...options })
        .then((res) => res.data)
        .catch((err) => {
            if (showErrorDialog) {
                setTimeout(() => {
                    throw err;
                }, 250);
            }
            throw err;
        });
}

export function catchErrorStatus(promise, status, callback) {
    return promise.catch((err) => {
        if (err.response && err.response.status === status) {
            callback(err.response.data);
        } else {
            throw err;
        }
    });
}

export function postPutJson(path, body, method, showErrorDialog = true, result = true) {
    return axiosFetch(path, { method: method, data: body }, {}, showErrorDialog, result);
}

export function get_shops(cb) {
    return client.get("/v1/shops?limit=999").then(lookupData).then(cb);
}

export function get_tables(cb) {
    return client.get("/v1/tables?limit=999").then(lookupData).then(cb);
}

export function get_all_flavors(cb) {
    return client.get(`v1/flavors?limit=999`).then(lookupData).then(cb);
}

export function get_all_strains(cb) {
    return client.get(`v1/strains?limit=999`).then(lookupData).then(cb);
}

export function get_all_tags(cb) {
    return client.get(`v1/tags?limit=999`).then(lookupData).then(cb);
}

export function get_all_resources_by_type(type, shopId, cb) {
    const url = shopId ? `v1/${type}?limit=999&filter=shop_id%3A${shopId}` : `v1/${type}?limit=999`;
    return client.get(url).then(lookupData).then(cb);
}

export function get_resource_by_id(type, id, cb) {
    return client.get(`/v1/${type}/${id}`).then(lookupData).then(cb);
}

export function get_resource_is_deletable(type, id, cb) {
    return client.get(`/v1/${type}/is-deletable/${id}`).then(lookupData).then(cb);
}

export function get_all_products_generic(table, search, cb) {
    return client.get(`/v1/${table}?limit=999`).then(lookupData).then(cb);
}

export function get_product_by_id_generic(table, id, shopId, cb) {
    return client.get(`/v1/${table}/${id}?shop=${shopId}`).then(lookupData).then(cb);
}

export function get_shop_by_id(id, cb) {
    return client.get(`/v1/shops/${id}`).then(lookupData).then(cb);
}

export function get_shop_group_by_shop_id(shop_id, cb) {
    return client.get(`/v1/shop-groups/shop-id/${shop_id}`).then(lookupData).then(cb);
}

export function startForm(formKey, userInputs, shopId) {
    console.log("Userinputs", userInputs);
    const url = shopId ? `/v1/forms/${formKey}?shop_id=${shopId}` : `/v1/forms/${formKey}`;
    return postPutJson(url, userInputs, "post", false, true);
}

export function get_all_shop_groups(cb) {
    return client.get(`v1/shop-groups?limit=999`).then(lookupData).then(cb);
}

export function get_all_users(cb) {
    return client.get(`v1/users?limit=999`).then(lookupData).then(cb);
}

export function get_all_roles(cb) {
    return client.get(`v1/roles?limit=999`).then(lookupData).then(cb);
}

export function get_screens_by_shop_id(id, cb) {
    return client.get(`/v1/screens/?filter=shop_id%3A${id}`).then(lookupData).then(cb);
}

export function get_screen_by_id(id, cb) {
    return client.get(`/v1/screens/${id}`).then(lookupData).then(cb);
}

export const fetch_pricelist_prices_v1 = async (shopId) => {
    const res = await client.get(`${API_URL}/v1/shops/${shopId}`);
    return res.data;
};

export const fetch_pricelist_prices_v2 = async (shopId, screenId) => {
    const res = await client.get(`${API_URL}/v1/screens/pricelist/${shopId}/${screenId}`);
    return res.data;
};

export const fetch_horeca_prices_v1 = async (shopId) => {
    const res = await client.get(`${API_URL}/v1/shops/${shopId}?is_horeca=true`);
    return res.data;
};

export const get_signed_image_url = async (fileName) => {
    const response = await client.get(`${API_URL}/v1/images/signed-url/${fileName}`);
    return response.data;
};

export default client;
